// Must stay the first import — Sentry.init() has to run before React, the router,
// or any app module loads, or those frames go uninstrumented.
import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/print.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './styles/theme';
import {HelmetProvider} from 'react-helmet-async';
import {SnackbarProvider} from 'notistack';
// Import Ramda setup to make it available globally
import './utils/ramdaSetup';
import './utils/compatShims';

// Suppress console.log and console.info in production builds (keep warn/error for debugging)
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <AuthProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline/>
                        {/* Inside ThemeProvider so toasts inherit light/dark.
                            Without this provider notistack's default context is
                            a silent no-op — every enqueueSnackbar in the app
                            was doing nothing. */}
                        <SnackbarProvider
                            maxSnack={3}
                            autoHideDuration={4000}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        >
                            <App/>
                        </SnackbarProvider>
                    </ThemeProvider>
                </AuthProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);
